module.exports = __webpack_public_path__ + "static/media/violinplay_foreverforloops.30ebb3f7.wav";